import Http from '@rootCommon/services/http';
import { PROFILE } from '@rootCommon/constants/end-points';
import { Profile } from '@rootCommon/types/profile';
import { ChangePassword } from '@rootCommon/types/password';

const PROFILE_USER = `${PROFILE}/user`;
const CHANGE_PASSWORD = `${PROFILE}/change-password/user`;

class ProfileService extends Http {
  get = async (): Promise<Profile> => {
    const res = await Http.get<Profile>(PROFILE_USER);

    return res.data;
  };

  update = async (data: Profile): Promise<Profile> => {
    const res = await Http.put<Profile, Profile>(PROFILE, data);

    return res.data;
  };

  changePassword = async (data: ChangePassword): Promise<ChangePassword> => {
    const res = await Http.put<ChangePassword, ChangePassword>(CHANGE_PASSWORD, data);

    return res.data;
  };
}

export default new ProfileService();
